import { sourceServices } from '@tm/client-app/src/review/import/sources'
import { ThirdPartyCollectData } from '@tm/types/survey/entities'
import { styled } from 'goober'
import React from 'react'

const ThirdPartyCollectContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2.5em;
`

const ThirdPartyCollectLinkContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  max-width: 600px;
`

const ThirdPartyCollectLink = styled('a')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px 24px 16px;
  gap: 8px;
  width: 137px;
  height: 136px;
  background: #f9fafb;
  border-radius: 8px;
  flex: none;
  order: 0;
  flex-grow: 0;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: #636e81;
  text-decoration: none;
  transition: 0.3s background ease-in-out, 0.3s color ease-in-out;
  &:hover {
    background: #e6e6e8;
    color: #232323;
  }
`

export const ThirdPartyCollect = ({ value }: { value?: ThirdPartyCollectData }) => {
  if (!value) {
    return null
  }

  if (!value.sources || (value.sources && !value.sources.length)) {
    return null
  }

  return (
    <ThirdPartyCollectContainer>
      <ThirdPartyCollectLinkContainer>
        {value.sources.map(source => {
          const Icon = sourceServices.find(service => service.source === source.source)?.icon
          return (
            <ThirdPartyCollectLink href={source.url} rel="noreferrer" target="_blank" key={source.id}>
              {Icon ? <Icon /> : null}
              {source.name}
            </ThirdPartyCollectLink>
          )
        })}
      </ThirdPartyCollectLinkContainer>
    </ThirdPartyCollectContainer>
  )
}
